import { Component, Input } from '@angular/core';
import { Config, ConfigService } from 'src/app/services/config.service';

/**
 * Support the display the animated loading indicator.
 */
@Component({
  selector: 'iui-busy',
  templateUrl: './busy.component.html',
  styleUrls: ['./busy.component.scss']
})
export class IuiBusyComponent {

  /**
   * Is the busy display visible or not.  Controlled by show and hide methods.
   */
  public visible = false;
  public showSupplementalInfo = false;
  public supplementalInfoMessage?: string;
  public supplementalInfoMessageWaitTime?: number;

  private showSupplementalInfoTimer?: number;

  /**
   * How long to wait before toggling between show and hide in the event multiple
   * calls are made back to back.  Don't want to show/hide/show in short period of time.
   * Defaults to 10 milliseconds.
   */
  @Input() public timeoutMS = 10;

  constructor(configService: ConfigService) {
    configService.getConfig().subscribe((cfg:Config) => {
      if (cfg.supplementalBusyInfo) {
        this.supplementalInfoMessage = cfg.supplementalBusyInfo.text;
        this.supplementalInfoMessageWaitTime = cfg.supplementalBusyInfo.waitTime;
      }
    });
  }


  /**
   * Show the busy indicator after timeoutMS milliseconds.
   */
  show(): void {
    // this.logger.debug("busy show");
    setTimeout(() => {
      this.visible = true;

      if (this.supplementalInfoMessage && this.supplementalInfoMessageWaitTime && !this.showSupplementalInfoTimer) {
        // console.debug('show supp in ' + this.supplementalInfoMessageWaitTime + ' seconds.');
        this.showSupplementalInfoTimer = window.setTimeout(() => {
            this.showSupplementalInfo = true;
        }, 1000 * this.supplementalInfoMessageWaitTime);
      }

    }, this.timeoutMS);
  }

  /**
   * Hide the busy indicator after timeoutMS milliseconds.
   */
  hide(): void {
    // this.logger.debug("busy hide");
    setTimeout(() => {
      if (this.visible === true) {
        this.visible = false;
        if (this.showSupplementalInfoTimer) {
          window.clearTimeout(this.showSupplementalInfoTimer);
          this.showSupplementalInfo = false;
        }
        delete this.showSupplementalInfoTimer;
      }
    }, this.timeoutMS);
  }
}
